import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "react-query";
import { RegAuthAppStore } from "./core/redux/reduxStore";

const root = ReactDOM.createRoot(
  document.getElementById("root")! as HTMLElement
);

const queryClient = new QueryClient();

root.render(
    <Provider store={RegAuthAppStore}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
);


